module.exports = "pegasus/assets/blocks/column-2-theme5.png";